/* eslint-disable prettier/prettier */
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import LocationContext from '@context/location/locationContext';
import NotificationCountContext from '@context/NotificationCount/notificationCountContext';
import ShowErrorToastContext from '@context/showErrorToast/showErrorToastContext';
import { getNotificationCount } from '@shared-layouts/DefaultLayout/helper';
import NotificationContext, {
  NotificationType
} from '@src/context/Notification/notificationContext';

import HeaderTab from './HeaderTab';
import { TAB_TYPE } from './helper';
import NotificationFooter from './NotificationFooter';
import NotificationList from './NotificationList';
import Summary from './Summary';

const Notification = () => {

  const [{ showErrorToastSetState }] = useContext(ShowErrorToastContext);

  const [{ notificationState, notificationSetState }] = useContext(NotificationContext);

  const [{ notificationCountState, notificationCountStateSetState }] =
    useContext(NotificationCountContext);

  const [{ locationState }] = useContext(LocationContext);
  const { property, store, revenueCenter, date } = locationState;

  const getData = async (filters: FilterType) => {
    const res = await getNotificationCount(filters);
    if (!res.error) {
      notificationCountStateSetState({ count: res?.data });
    } else {
      showErrorToastSetState({
        errorMessage: res.error || "",
        errorTitle: "Unable to Fetch Notification", open: true
      });
    }
  };

  useEffect(() => {
    const filter: FilterType = {
      property,
      store,
      rvc: revenueCenter,
      date,
    };
    getData(filter);
  }, [property, store, revenueCenter, date, notificationCountState?.count]);

  const navigate = useNavigate();
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    notificationSetState((prev: NotificationType) => {
      const notification = {
        ...prev,
        currentTab: newValue,
      }
      localStorage.setItem("notification", JSON.stringify(notification));
      return notification
    })
  };

  const handleClick = (e: string) => {
    notificationSetState((prev: NotificationType) => {
      const filterTypeState = prev?.filterType?.map((event: NotificationFitlerType) => {
        const { value, key } = event;
        if (value === e) {
          return { key, value, isSelected: true };
        }
        return event;
      })

      const notification = {
        ...prev,
        filterType: filterTypeState
      }

      localStorage.setItem("notification", JSON.stringify(notification));
      return notification
    })
  }

  const handleDelete = (e: string) => {
    notificationSetState((prev: NotificationType) => {
      const filterTypeState = prev?.filterType?.map((event: NotificationFitlerType) => {
        const { value, key } = event;
        if (value === e) {
          return { key, value, isSelected: false };
        }
        return event;
      })
      const notification = {
        ...prev,
        filterType: filterTypeState
      }
      localStorage.setItem("notification", JSON.stringify(notification));
      return notification
    })

  };

  const handleViewDetailsButton = (propertyShortName: string, checkNo: string, notificationId: string) => {
    navigate(`/notification-center/${propertyShortName}/${checkNo}/${notificationId}`);
  };

  const getActiveTab = (currentActiveTab: number) => {
    switch (currentActiveTab) {
    case TAB_TYPE.ALL:
      return (
        <NotificationList
          handleViewDetailsButton={handleViewDetailsButton}
          filterType={notificationState?.filterType}
          handleClick={handleClick}
          handleDelete={handleDelete}
          count={notificationCountState?.count}
        />
      );
    case TAB_TYPE.UNREAD:
      return (
        <NotificationList
          handleViewDetailsButton={handleViewDetailsButton}
          filterType={notificationState?.filterType}
          handleClick={handleClick}
          handleDelete={handleDelete}
          count={notificationCountState?.count}
          unreadOnly
        />
      );
    case TAB_TYPE.SUMMARY:
      return <Summary />;
    default:
      return (
        <NotificationList
          handleViewDetailsButton={handleViewDetailsButton}
          filterType={notificationState?.filterType}
          handleClick={handleClick}
          handleDelete={handleDelete}
          count={notificationCountState?.count}
        />
      );
    }
  };

  return (
    <>
      <>
        <HeaderTab currentTab={notificationState?.currentTab} handleChange={handleChange} />
        {getActiveTab(notificationState?.currentTab)}
      </>
      {!(TAB_TYPE.SUMMARY === notificationState?.currentTab) && <NotificationFooter count={notificationCountState?.count} notificationCountStateSetState={notificationCountStateSetState} />}
    </>
  );
};

export default Notification;
